import { baseApi } from '@/lib/api/baseApi';
import { materialsEndpoints } from './materials.queries';

export const materialsApi = baseApi.injectEndpoints({ endpoints: materialsEndpoints });

export const {
  useGetAccountMaterialsQuery,
  useGetMaterialFormQuery,
  useCreateMaterialMutation,
  useUpdateMaterialMutation,
} = materialsApi;
